export enum MenuItemButtonType {
    Plus,
    Minus
}
